import styled from '@emotion/styled'
import { FlexBox } from 'app/components/Layout/FlexBox'
import { Link } from 'gatsby'
import React, { memo } from 'react'
import * as Icon from 'react-feather'
import LazyLoad from 'react-lazyload'

export interface Props {
  image?: string
  title: string
  URL: string
  weight?: number
}

export const Item = memo(function Item({ image, title, URL }: Props) {
  if (!title || !URL) {
    return null
  }

  return (
    <Container to={URL}>
      {image ? (
        <LazyLoad>
          <BackgroundImage
            className="banner-cta-bg"
            style={{ backgroundImage: `url(${image})` }}
          />
        </LazyLoad>
      ) : null}
      <Text dial={4} row space="between">
        <Title>{title}</Title>
        <Icon.ArrowRight />
      </Text>
    </Container>
  )
})

const Container = styled(Link)`
  width: 50%;
  background: ${({ theme }) => theme.colors.variants.neutralLight3};
  overflow: hidden;
  padding-bottom: 35%;
  position: relative;
  &:hover {
    .banner-cta-bg {
      transform: scale(1.1);
    }
    svg {
      transform: translateX(1.25rem);
    }
  }

  @media (max-width: 767px) {
    padding-bottom: 46%;
  }
`

const BackgroundImage = styled.div`
  width: 100%;
  height: 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  position: absolute;
  top: 0;
  left: 0;
  transition: 0.2s ease-in-out;
`

const Text = styled(FlexBox)`
  width: 75%;
  background: ${({ theme }) => theme.colors.variants.neutralDark4};
  padding: 1.75rem 3.125rem 1.75rem 1.875rem;
  position: absolute;
  bottom: 0;
  left: 0;
  svg {
    width: auto;
    height: 1.5rem;
    stroke: ${({ theme }) => theme.colors.variants.primaryDark1};
    stroke-width: 2;
    transition: 0.3s ease-in-out;
  }

  @media (max-width: 1023px) {
    padding: 1.25rem 2.375rem 1.25rem 1.375rem;
  }

  @media (max-width: 767px) {
    width: 90%;
    padding: 0.75rem 1.5rem;
  }
`

const Title = styled.h4`
  color: ${({ theme }) => theme.colors.variants.neutralLight4};
  font-family: ${({ theme }) => theme.fontFamily.paragraph};
  font-size: 0.8125rem;
  font-weight: 600;
  letter-spacing: 2px;
  line-height: 1.75rem;
  text-transform: uppercase;
`
